const cities = [
  { name: "Gainesville", zips: "32601–32612" },
  { name: "Alachua", zips: "32615" },
  { name: "Archer", zips: "32618" },
  { name: "Hawthorne", zips: "32640" },
  { name: "High Springs", zips: "32643" },
  { name: "Keystone Heights", zips: "32656" },
  { name: "Lake City", zips: "32024–32056" },
  { name: "Micanopy", zips: "32667" },
  { name: "Newberry", zips: "32669" },
  { name: "Ocala", zips: "34470–34482" },
  { name: "Palatka", zips: "32177–32178" },
  { name: "Starke", zips: "32091" },
  { name: "Waldo", zips: "32694" },
  { name: "Williston", zips: "32696" },
];

export const landmarks = [
  { name: "Gainesville Regional Airport (GNV)", distance: "~5 miles", icon: "ri-flight-takeoff-line", desc: "Closest airport — daily commercial flights via American, Delta, and Silver Airways", url: "https://www.gra-gnv.com/", schemaType: "Airport" },
  { name: "Jacksonville International Airport (JAX)", distance: "~75 miles", icon: "ri-flight-takeoff-line", desc: "Larger airport with more connections — northeast via US-301 and I-10", url: "https://www.flyjacksonville.com/", schemaType: "Airport" },
  { name: "I-75", distance: "~6 miles", icon: "ri-road-map-line", desc: "Primary north-south interstate connecting Gainesville to Ocala and Lake City", url: "https://en.wikipedia.org/wiki/Interstate_75_in_Florida", schemaType: "CivicStructure" },
  { name: "University of Florida (UF)", distance: "Adjacent", icon: "ri-building-2-line", desc: "Flagship state university — 55,000+ students, faculty, and staff", url: "https://www.ufl.edu/", schemaType: "TouristAttraction" },
  { name: "UF Health Shands Hospital", distance: "~2 miles", icon: "ri-hospital-line", desc: "Major academic medical center serving North Central Florida", url: "https://ufhealth.org/shands-hospital", schemaType: "TouristAttraction" },
  { name: "Ben Hill Griffin Stadium", distance: "~1 mile", icon: "ri-trophy-line", desc: "The Swamp — 90,000-seat UF football stadium on University Avenue", url: "https://floridagators.com/", schemaType: "TouristAttraction" },
  { name: "Paynes Prairie Preserve State Park", distance: "~8 miles", icon: "ri-landscape-line", desc: "21,000-acre state preserve with wild horses, bison, and elevated boardwalk trails", url: "https://www.floridastateparks.org/parks-and-trails/paynes-prairie-preserve-state-park", schemaType: "TouristAttraction" },
  { name: "Devil's Millhopper Geological State Park", distance: "~5 miles", icon: "ri-landscape-line", desc: "120-foot-deep limestone sinkhole with rainforest microclimate and boardwalk", url: "https://www.floridastateparks.org/parks-and-trails/devils-millhopper-geological-state-park", schemaType: "TouristAttraction" },
];

const benefits = [
  {
    icon: "ri-computer-line",
    title: "Start 100% Online",
    desc: "No office visit required to begin. Complete your order from home or work in minutes.",
  },
  {
    icon: "ri-truck-line",
    title: "Ship Your Documents",
    desc: "Use overnight shipping to send your documents directly to us — we handle the rest.",
  },
  {
    icon: "ri-shield-check-line",
    title: "Expert Document Review",
    desc: "Every application is reviewed by our team before submission to reduce errors and delays.",
  },
  {
    icon: "ri-calendar-check-line",
    title: "Reserved Agency Access",
    desc: "We hold reserved submission slots at the regional passport agency — no public appointment needed.",
  },
];

export default function GainesvilleLocalAreaSection() {
  return (
    <section id="service-area" className="bg-[#F7F8FA] pt-6 md:pt-8 pb-20 md:pb-28">
      <div className="max-w-7xl mx-auto px-4 md:px-8">
        <div className="text-center mb-14">
          <p className="text-[#F6C344] text-xs font-bold uppercase tracking-[0.2em] mb-3">Service Area</p>
          <h2 className="font-serif text-3xl md:text-4xl font-bold text-[#1A365D] mb-4">
            Serving Gainesville &amp; North Central Florida
          </h2>
          <p className="text-gray-500 max-w-2xl mx-auto text-base leading-relaxed">
            Whether you are in Gainesville, Ocala, Lake City, or anywhere in Alachua, Marion, Columbia, or surrounding counties, Fast Passport Center makes expedited passport processing simple — as a registered courier, we have guaranteed submission availability, no agency lines, no guessing.
          </p>
        </div>

        <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 items-start">
          {/* Left — FPC Office + How It Works */}
          <div>
            {/* FPC Service Card */}
            <div className="bg-[#1A365D] rounded-lg p-7 mb-8 text-white">
              <div className="flex items-center gap-3 mb-5">
                <div className="w-11 h-11 flex items-center justify-center rounded-full bg-[#F6C344] flex-shrink-0">
                  <i className="ri-building-2-line text-[#1A365D] text-xl"></i>
                </div>
                <div>
                  <p className="font-bold text-base">Fast Passport Center — Tampa (Nearest Office)</p>
                  <p className="text-white/60 text-xs mt-0.5">Tampa, FL — approximately 120 miles south of Gainesville</p>
                </div>
              </div>
              <p className="text-white/70 text-sm mb-1">
                <i className="ri-map-pin-line text-[#F6C344] mr-1.5"></i>
                Nearest office to Gainesville — we serve all of Alachua, Marion, Columbia, and Bradford counties
              </p>
              <p className="text-white/50 text-xs mb-5 ml-5">Courier pickup available throughout Gainesville, Ocala, and Lake City</p>
              <div className="border-t border-white/10 pt-5">
                <p className="text-white/80 text-sm leading-relaxed mb-4">
                  After signing up online, choose what works best for you: <strong className="text-white">courier pickup</strong> from your home or office in most cases, <strong className="text-white">ship with our prepaid label</strong> from any UPS/FedEx location in Gainesville, Ocala, or Lake City, or <strong className="text-white">schedule a drop-off</strong> at our Tampa office. Most clients ship overnight — no visit required.
                </p>
                <a
                  href="https://fastpassportcenter.com/checkout/"
                  className="inline-flex items-center gap-2 bg-[#F6C344] hover:bg-[#e5b430] text-[#1A365D] font-bold text-sm px-5 py-2.5 rounded-md transition-all whitespace-nowrap"
                >
                  Start My Passport <i className="ri-arrow-right-line"></i>
                </a>
              </div>
            </div>

            {/* How FPC Helps */}
            <div className="grid grid-cols-1 sm:grid-cols-2 gap-4">
              {benefits.map((b, i) => (
                <div key={i} className="bg-white rounded-lg p-5 border border-gray-200">
                  <div className="w-9 h-9 flex items-center justify-center rounded-full bg-[#F6C344]/15 mb-3">
                    <i className={`${b.icon} text-[#1A365D] text-base`}></i>
                  </div>
                  <p className="font-bold text-[#1A365D] text-sm mb-1">{b.title}</p>
                  <p className="text-gray-500 text-xs leading-relaxed">{b.desc}</p>
                </div>
              ))}
            </div>
          </div>

          {/* Right — Cities We Serve + Trust strip */}
          <div>
            <div className="bg-white rounded-lg p-7 mb-6 border border-gray-200">
              <h3 className="font-bold text-[#1A365D] text-sm uppercase tracking-wide mb-5">
                <i className="ri-map-pin-2-line text-[#F6C344] mr-2"></i>
                Cities &amp; Communities We Serve
              </h3>
              <div className="space-y-1.5">
                {cities.map((city, i) => (
                  <div
                    key={i}
                    className="flex items-center justify-between py-2.5 px-3 bg-[#F7F8FA] rounded-md"
                  >
                    <div className="flex items-center gap-2.5">
                      <i className="ri-checkbox-circle-fill text-[#F6C344] text-sm"></i>
                      <span className="text-[#1A365D] font-medium text-sm">{city.name}</span>
                    </div>
                    {city.zips && (
                      <span className="text-gray-400 text-xs font-mono">{city.zips}</span>
                    )}
                  </div>
                ))}
              </div>
              <p className="text-gray-500 text-xs mt-4 leading-relaxed">
                Anywhere in Alachua, Marion, Columbia, Bradford, Putnam, and Levy counties — start online, ship overnight, and we handle the rest. As a registered courier, we have guaranteed submission availability.
              </p>
              <div className="mt-4 pt-4 border-t border-gray-100">
                <p className="text-gray-400 text-xs font-semibold uppercase tracking-wider mb-3">Nearby Cities We Serve</p>
                <div className="flex flex-wrap gap-2">
                  {[
                    { name: "Ocala", href: "/florida" },
                    { name: "Lake City", href: "/florida" },
                    { name: "Tallahassee", href: "/tallahassee" },
                    { name: "Orlando", href: "/orlando" },
                    { name: "Tampa", href: "/tampa" },
                    { name: "Cedar Key", href: "/cedar-key" },
                    { name: "Florida Directory", href: "/florida" },
                  ].map((link) => (
                    <a
                      key={link.href + link.name}
                      href={link.href}
                      className="inline-flex items-center gap-1 text-xs text-[#1A365D] hover:text-[#F6C344] font-medium transition-colors bg-white border border-gray-200 hover:border-[#F6C344] rounded-full px-3 py-1.5 whitespace-nowrap"
                    >
                      {link.name} <i className="ri-arrow-right-line text-[10px]"></i>
                    </a>
                  ))}
                </div>
              </div>
            </div>

            {/* Trust credentials strip */}
            <div className="bg-[#1A365D] rounded-lg p-5">
              <p className="text-white/50 text-xs uppercase tracking-widest font-semibold mb-4">Why Travelers Choose Fast Passport Center</p>
              <div className="grid grid-cols-2 gap-3">
                {[
                  { icon: "ri-government-line", value: "Registered Courier", label: "U.S. Department of State" },
                  { icon: "ri-award-line", value: "A+ Rating", label: "Better Business Bureau" },
                  { icon: "ri-calendar-check-line", value: "20+ Years", label: "Serving Travelers Nationwide" },
                  { icon: "ri-customer-service-2-line", value: "Real Humans", label: "Live Support — Not a Bot" },
                ].map((item, i) => (
                  <a
                    key={i}
                    href="https://fastpassportcenter.com"
                    className="flex items-center gap-2.5 bg-white/5 hover:bg-white/10 rounded-md px-3 py-2.5 transition-colors cursor-pointer"
                  >
                    <div className="w-8 h-8 flex items-center justify-center rounded-full bg-[#F6C344]/15 flex-shrink-0">
                      <i className={`${item.icon} text-sm text-[#F6C344]`}></i>
                    </div>
                    <div className="text-left">
                      <span className="text-white text-xs font-bold block leading-tight">{item.value}</span>
                      <span className="text-white/50 text-xs leading-tight block">{item.label}</span>
                    </div>
                  </a>
                ))}
              </div>
            </div>

            {/* Nearby Landmarks & Airports */}
            <div className="mt-6">
              <div className="flex items-center gap-2 mb-3">
                <div className="w-6 h-6 flex items-center justify-center rounded-full bg-[#F6C344]/15">
                  <i className="ri-landscape-line text-[#1A365D] text-xs"></i>
                </div>
                <h3 className="font-semibold text-[#1A365D] text-sm uppercase tracking-wide">Nearby Landmarks &amp; Airports</h3>
              </div>
              <div className="flex flex-wrap gap-1.5">
                {landmarks.map((item) => (
                  <span
                    key={item.name}
                    className="inline-flex items-center gap-1.5 bg-[#F7F8FA] border border-gray-200/80 rounded-full px-3 py-1.5 hover:border-[#F6C344] transition-colors cursor-default whitespace-nowrap"
                    title={item.desc}
                  >
                    <i className={`${item.icon} text-[#1A365D] text-[10px]`}></i>
                    <span className="text-[#1A365D] font-medium text-[11px]">{item.name}</span>
                    <span className="text-[#F6C344] font-semibold text-[10px]">{item.distance}</span>
                  </span>
                ))}
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}